import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/img/logo-small.png'
import _imports_1 from '@/assets/images/img/icons/instagram.svg'
import _imports_2 from '@/assets/telegram_mt_social.svg'
import _imports_3 from '@/assets/images/img/icons/in.svg'


const _withScopeId = n => (_pushScopeId("data-v-097c8c83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "footer__block" }
const _hoisted_4 = { class: "footer__left-top" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "footer__logo"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo"
  })
], -1))
const _hoisted_6 = { class: "footer__copyright" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<a target=\"_blank\" href=\"https://instagram.com/masons_traffic?igshid=YmM0MjE2YWMzOA==\" class=\"footer__icon\" data-v-097c8c83><img src=\"" + _imports_1 + "\" alt=\"instagram\" data-v-097c8c83></a><a target=\"_blank\" href=\"https://t.me/masoninfo\" class=\"footer__icon\" data-v-097c8c83><img src=\"" + _imports_2 + "\" alt=\"telegram\" data-v-097c8c83></a><a target=\"_blank\" href=\"https://www.linkedin.com/company/masons-traffic\" class=\"footer__icon\" data-v-097c8c83><img src=\"" + _imports_3 + "\" alt=\"linkedin\" data-v-097c8c83></a>", 3)
const _hoisted_10 = { class: "footer__wrap" }
const _hoisted_11 = { class: "footer__menu-nav" }
const _hoisted_12 = { href: "#" }
const _hoisted_13 = { href: "#" }
const _hoisted_14 = { href: "/#faq" }
const _hoisted_15 = {
  key: 0,
  class: "footer__menu-contact"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "13",
  viewBox: "0 0 15 13",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.51807 7.91373L11.0723 3.31866L4.24096 6.96303M6.51807 7.91373L8.2747 9.33979M6.51807 7.91373L5.86747 11.3996M4.24096 6.96303L0.5 5.69542L14 0.625L11.3976 11.875L8.2747 9.33979M4.24096 6.96303L5.86747 11.3996M5.86747 11.3996L8.2747 9.33979",
    stroke: "#F6FF00",
    "stroke-width": "0.75",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_17 = {
  key: 1,
  class: "footer__menu-contact"
}
const _hoisted_18 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "13",
  viewBox: "0 0 15 13",
  fill: "none"
}
const _hoisted_19 = ["stroke"]
const _hoisted_20 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "13",
  viewBox: "0 0 15 13",
  fill: "none"
}
const _hoisted_21 = ["stroke"]
const _hoisted_22 = {
  key: 2,
  class: "footer__menu-contact"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.25 6C2.25 5.60218 2.40804 5.22064 2.68934 4.93934C2.97064 4.65804 3.35218 4.5 3.75 4.5H14.25C14.6478 4.5 15.0294 4.65804 15.3107 4.93934C15.592 5.22064 15.75 5.60218 15.75 6V13.5C15.75 13.8978 15.592 14.2794 15.3107 14.5607C15.0294 14.842 14.6478 15 14.25 15H3.75C3.35218 15 2.97064 14.842 2.68934 14.5607C2.40804 14.2794 2.25 13.8978 2.25 13.5V6Z",
    stroke: "#01AAFC",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.25 6L9 10.5L15.75 6",
    stroke: "#01AAFC",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_24 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "13",
  viewBox: "0 0 15 13",
  fill: "none"
}
const _hoisted_25 = ["stroke"]
const _hoisted_26 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "13",
  viewBox: "0 0 15 13",
  fill: "none"
}
const _hoisted_27 = ["stroke"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", null, "© " + _toDisplayString(_ctx.$t('footer.copy')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('footer.reserv')), 1)
          ])
        ]),
        _createElementVNode("div", {
          class: "footer__left-bottom",
          style: _normalizeStyle({ '--theme-color': $options.activeColor })
        }, [
          _createElementVNode("p", {
            style: _normalizeStyle({ color: $options.activeColor })
          }, _toDisplayString(_ctx.$t('footer.social')), 5),
          _hoisted_7
        ], 4)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("ul", _hoisted_11, [
          _createElementVNode("li", {
            style: _normalizeStyle({ color: $options.activeColor })
          }, _toDisplayString(_ctx.$t('footer.nav')), 5),
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.$t('footer.navLinks.0.label')), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.$t('footer.navLinks.1.label')), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_14, _toDisplayString(_ctx.$t('footer.navLinks.2.label')), 1)
          ])
        ]),
        ($options.activeService === 'clickbait')
          ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
              _createElementVNode("li", {
                style: _normalizeStyle({ color: $options.activeColor })
              }, _toDisplayString(_ctx.$t('footer.contact')), 5),
              _createElementVNode("li", null, [
                _hoisted_16,
                _createElementVNode("a", {
                  target: "_blank",
                  href: "https://t.me/creogamble",
                  style: _normalizeStyle({ '--theme-color': $options.activeColor })
                }, " MT ClickBait Manager ", 4)
              ])
            ]))
          : ($options.activeService === 'shop')
            ? (_openBlock(), _createElementBlock("ul", _hoisted_17, [
                _createElementVNode("li", {
                  style: _normalizeStyle({ color: $options.activeColor })
                }, _toDisplayString(_ctx.$t('footer.contact')), 5),
                _createElementVNode("li", null, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_18, [
                    _createElementVNode("path", {
                      d: "M6.51807 7.91373L11.0723 3.31866L4.24096 6.96303M6.51807 7.91373L8.2747 9.33979M6.51807 7.91373L5.86747 11.3996M4.24096 6.96303L0.5 5.69542L14 0.625L11.3976 11.875L8.2747 9.33979M4.24096 6.96303L5.86747 11.3996M5.86747 11.3996L8.2747 9.33979",
                      stroke: $options.activeColor,
                      "stroke-width": "0.75",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, 8, _hoisted_19)
                  ])),
                  _createElementVNode("a", {
                    target: "_blank",
                    href: "https://t.me/MT_SHOP_Support",
                    style: _normalizeStyle({ '--theme-color': $options.activeColor })
                  }, " MT Shop support ", 4)
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_20, [
                    _createElementVNode("path", {
                      d: "M6.51807 7.91373L11.0723 3.31866L4.24096 6.96303M6.51807 7.91373L8.2747 9.33979M6.51807 7.91373L5.86747 11.3996M4.24096 6.96303L0.5 5.69542L14 0.625L11.3976 11.875L8.2747 9.33979M4.24096 6.96303L5.86747 11.3996M5.86747 11.3996L8.2747 9.33979",
                      stroke: $options.activeColor,
                      "stroke-width": "0.75",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, 8, _hoisted_21)
                  ])),
                  _createElementVNode("a", {
                    target: "_blank",
                    href: "https://t.me/maksmt",
                    style: _normalizeStyle({ '--theme-color': $options.activeColor })
                  }, " MT Shop Team Lead ", 4)
                ])
              ]))
            : ($options.activeService === 'agency')
              ? (_openBlock(), _createElementBlock("ul", _hoisted_22, [
                  _createElementVNode("li", {
                    style: _normalizeStyle({ color: $options.activeColor })
                  }, _toDisplayString(_ctx.$t('footer.contact')), 5),
                  _createElementVNode("li", null, [
                    _hoisted_23,
                    _createElementVNode("a", {
                      target: "_blank",
                      href: "mailto:support@masons.partners",
                      style: _normalizeStyle({ '--theme-color': $options.activeColor })
                    }, " support@masons.partners ", 4)
                  ]),
                  _createElementVNode("li", null, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_24, [
                      _createElementVNode("path", {
                        d: "M6.51807 7.91373L11.0723 3.31866L4.24096 6.96303M6.51807 7.91373L8.2747 9.33979M6.51807 7.91373L5.86747 11.3996M4.24096 6.96303L0.5 5.69542L14 0.625L11.3976 11.875L8.2747 9.33979M4.24096 6.96303L5.86747 11.3996M5.86747 11.3996L8.2747 9.33979",
                        stroke: $options.activeColor,
                        "stroke-width": "0.75",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, 8, _hoisted_25)
                    ])),
                    _createElementVNode("a", {
                      target: "_blank",
                      href: "https://t.me/masonsinfo",
                      style: _normalizeStyle({ '--theme-color': $options.activeColor })
                    }, " MT info ", 4)
                  ]),
                  _createElementVNode("li", null, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_26, [
                      _createElementVNode("path", {
                        d: "M6.51807 7.91373L11.0723 3.31866L4.24096 6.96303M6.51807 7.91373L8.2747 9.33979M6.51807 7.91373L5.86747 11.3996M4.24096 6.96303L0.5 5.69542L14 0.625L11.3976 11.875L8.2747 9.33979M4.24096 6.96303L5.86747 11.3996M5.86747 11.3996L8.2747 9.33979",
                        stroke: $options.activeColor,
                        "stroke-width": "0.75",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, 8, _hoisted_27)
                    ])),
                    _createElementVNode("a", {
                      target: "_blank",
                      href: "https://t.me/masonschat",
                      style: _normalizeStyle({ '--theme-color': $options.activeColor })
                    }, " MT chat ", 4)
                  ])
                ]))
              : _createCommentVNode("", true)
      ])
    ])
  ]))
}